import { render } from "./showcertificationadminView.vue?vue&type=template&id=b59e5458&scoped=true"
import script from "./showcertificationadminView.vue?vue&type=script&lang=js"
export * from "./showcertificationadminView.vue?vue&type=script&lang=js"

import "./showcertificationadminView.vue?vue&type=style&index=0&id=b59e5458&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b59e5458"]])

export default __exports__